// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  max-width: 1440px !important;
  padding: 0 30px;
  margin: 0 auto;
}

.bg-accent {
  background-color: #ff6f19 !important;
  color: #fff;
}

.tr {
  transition: 0.35s ease;
}

.m-text {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.title {
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 44px;
  letter-spacing: -0.8px;
}

.title-l {
  font-size: 30px;
  font-weight: 400;
  line-height: 41px;
  letter-spacing: -0.4px;
}

button.button,
.button {
  background-color: #eaeaea;
  padding: 13px 35px;
  border-radius: 40px;
  outline: none;
  border: none;
  transition: 0.35s ease;
  cursor: pointer;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #000;
  text-decoration: none;
}
button.button:active, button.button:hover,
.button:active,
.button:hover {
  background-color: #ff6f19;
  color: #eaeaea;
}

button.button-accent,
.button-accent {
  background-color: #ff6f19;
  color: #fff;
}
button.button-accent:active, button.button-accent:hover,
.button-accent:active,
.button-accent:hover {
  background-color: #eaeaea;
  color: #000;
}

button.button-accent-hov,
.button-accent-hov {
  background-color: #ff6f19;
  color: #fff;
}
button.button-accent-hov:active, button.button-accent-hov:hover,
.button-accent-hov:active,
.button-accent-hov:hover {
  background-color: rgba(255, 111, 25, 0.8);
}

.none {
  display: none !important;
}

.button-user {
  padding: 10px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

button.button-black,
.button-black {
  background-color: #000;
  color: #fff;
}
button.button-black:active, button.button-black:hover,
.button-black:active,
.button-black:hover {
  background-color: #ff6f19;
  color: #fff;
}

.link-accent {
  color: #ff6f19;
  text-decoration: none;
  transition: 0.35s ease;
}
.link-accent:active, .link-accent:hover {
  color: #000;
}

input[type=password]::-ms-reveal,
input[type=password]::-ms-clear {
  display: none;
}

@media (max-width: 728px) {
  .title {
    font-size: 2.25rem;
    line-height: 2.55rem;
  }
  .title-l {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  button.button:active, button.button:hover,
  .button:active,
  .button:hover {
    background-color: #eaeaea;
    color: #000;
  }
  button.button-accent:active, button.button-accent:hover,
  .button-accent:active,
  .button-accent:hover {
    background-color: #ff6f19;
    color: #fff;
  }
  button.button-accent-hov:active, button.button-accent-hov:hover,
  .button-accent-hov:active,
  .button-accent-hov:hover {
    background-color: #ff6f19;
  }
  button.button-black:active, button.button-black:hover,
  .button-black:active,
  .button-black:hover {
    background-color: #000;
  }
  .link-accent:active, .link-accent:hover {
    color: #ff6f19;
  }
}
@media (max-width: 440px) {
  .container {
    padding: 0 17px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAEA;EACC,4BAAA;EACA,eAAA;EACA,cAAA;AADD;;AAIA;EACC,oCAAA;EACA,WAAA;AADD;;AAIA;EACC,sBCVI;ADSL;;AAIA;EACC,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AADD;;AAIA;EACC,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AADD;;AAIA;EACC,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AADD;;AAIA;;EAEC,yBCxCM;EDyCN,kBAAA;EACA,mBCtCM;EDuCN,aAAA;EACA,YAAA;EACA,sBC1CI;ED2CJ,eAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WCjDM;EDkDN,qBAAA;AADD;AAGC;;;EAEC,yBCzDO;ED0DP,cCzDK;ADyDP;;AAIA;;EAEC,yBChEQ;EDiER,WAAA;AADD;AAGC;;;EAEC,yBCpEK;EDqEL,WCnEK;ADmEP;;AAIA;;EAEC,yBC5EQ;ED6ER,WAAA;AADD;AAGC;;;EAEC,yCAAA;AAAF;;AAIA;EACC,wBAAA;AADD;;AAIA;EACC,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADD;;AAIA;;EAEC,sBC/FM;EDgGN,WAAA;AADD;AAGC;;;EAEC,yBCvGO;EDwGP,WAAA;AAAF;;AAIA;EACC,cC7GQ;ED8GR,qBAAA;EACA,sBC3GI;AD0GL;AAGC;EAEC,WChHK;AD8GP;;AAMA;;EAEC,aAAA;AAHD;;AAMA;EACC;IACC,kBAAA;IACA,oBAAA;EAHA;EAMD;IACC,kBAAA;IACA,oBAAA;EAJA;EAUA;;;IAEC,yBC3II;ID4IJ,WC1II;EDmIL;EAcA;;;IAEC,yBCtJM;IDuJN,WAAA;EAXD;EAkBA;;;IAEC,yBChKM;EDiJP;EAsBA;;;IAEC,sBCtKI;EDmJL;EAyBA;IAEC,cCjLM;EDyJP;AACF;AA4BA;EACC;IACC,eAAA;EA1BA;AACF","sourcesContent":["@import './variables';\n\n.container {\n\tmax-width: 1440px !important;\n\tpadding: 0 30px;\n\tmargin: 0 auto;\n}\n\n.bg-accent {\n\tbackground-color: $accent !important;\n\tcolor: #fff;\n}\n\n.tr {\n\ttransition: $tr;\n}\n\n.m-text {\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n\n.title {\n\tfont-size: 40px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 44px;\n\tletter-spacing: -0.8px;\n}\n\n.title-l {\n\tfont-size: 30px;\n\tfont-weight: 400;\n\tline-height: 41px;\n\tletter-spacing: -0.4px;\n}\n\nbutton.button,\n.button {\n\tbackground-color: $grey;\n\tpadding: 13px 35px;\n\tborder-radius: $br40;\n\toutline: none;\n\tborder: none;\n\ttransition: $tr;\n\tcursor: pointer;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n\tcolor: $dark;\n\ttext-decoration: none;\n\n\t&:active,\n\t&:hover {\n\t\tbackground-color: $accent;\n\t\tcolor: $grey;\n\t}\n}\n\nbutton.button-accent,\n.button-accent {\n\tbackground-color: $accent;\n\tcolor: #fff;\n\n\t&:active,\n\t&:hover {\n\t\tbackground-color: $grey;\n\t\tcolor: $dark;\n\t}\n}\n\nbutton.button-accent-hov,\n.button-accent-hov {\n\tbackground-color: $accent;\n\tcolor: #fff;\n\n\t&:active,\n\t&:hover {\n\t\tbackground-color: rgba($accent, 0.8);\n\t}\n}\n\n.none {\n\tdisplay: none !important;\n}\n\n.button-user {\n\tpadding: 10px !important;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\nbutton.button-black,\n.button-black {\n\tbackground-color: $dark;\n\tcolor: #fff;\n\n\t&:active,\n\t&:hover {\n\t\tbackground-color: $accent;\n\t\tcolor: #fff;\n\t}\n}\n\n.link-accent {\n\tcolor: $accent;\n\ttext-decoration: none;\n\ttransition: $tr;\n\n\t&:active,\n\t&:hover {\n\t\tcolor: $dark;\n\t}\n}\n\ninput[type=password]::-ms-reveal,\ninput[type=password]::-ms-clear {\n\tdisplay: none;\n}\n\n@media (max-width: 728px) {\n\t.title {\n\t\tfont-size: 2.25rem;\n\t\tline-height: 2.55rem;\n\t}\n\n\t.title-l {\n\t\tfont-size: 1.25rem;\n\t\tline-height: 1.75rem;\n\t}\n\n\tbutton.button,\n\t.button {\n\n\t\t&:active,\n\t\t&:hover {\n\t\t\tbackground-color: $grey;\n\t\t\tcolor: $dark;\n\t\t}\n\t}\n\n\tbutton.button-accent,\n\t.button-accent {\n\n\t\t&:active,\n\t\t&:hover {\n\t\t\tbackground-color: $accent;\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n\n\tbutton.button-accent-hov,\n\t.button-accent-hov {\n\n\t\t&:active,\n\t\t&:hover {\n\t\t\tbackground-color: $accent;\n\t\t}\n\t}\n\n\tbutton.button-black,\n\t.button-black {\n\n\t\t&:active,\n\t\t&:hover {\n\t\t\tbackground-color: $dark;\n\t\t}\n\t}\n\n\t.link-accent {\n\n\t\t&:active,\n\t\t&:hover {\n\t\t\tcolor: $accent;\n\t\t}\n\t}\n}\n\n@media (max-width: 440px) {\n\t.container {\n\t\tpadding: 0 17px;\n\t}\n}","$accent: #ff6f19;\n$grey: #eaeaea;\n$w: #fff;\n$dark: #000;\n$tr: 0.35s ease;\n$br40: 40px;\n$Jost: 'Jost-Regular';\n$Jost300: 'Jost-Light';\n$Jost500: 'Jost-Medium';\n$Jost600: 'Jost-SemiBold';\n$Jost700: 'Jost-Bold';\n$Jost800: 'Jost-ExtraBold';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
